module.exports = __webpack_public_path__ + "static/media/entregarinju7.9bc542bd.webp";